let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZetx"), load("34i4a"), load("gr9Xf")]).then(() => parcelRequire('iFpSu'));